module.exports = __webpack_public_path__ + "img/hezuologo.d8a660d6.png";